import React, { useEffect } from "react";
import { Spinner } from '../utils/Spinner';
import { useSpinner } from "../../../hooks/useSpinner";
import Draggable from "react-draggable";

export const Modal = ({
    isOpen, 
    closeModal, 
    action, 
    children, 
    title, 
    cerrarAlGuardar = false,
    textButtons = { confirm: 'Guardar', denied: 'Cancelar' }, 
    validButton = { confirm: true , denied: true},
    paddingModal = true,
    isDragrable = true
}) => {
    const [ spinner, mostrarSpinner, ocultarSpinner ] = useSpinner(); 

    useEffect(() => {
        const eventoEsc = (event) => {
            if (event.key === 'Escape') {
                closeModal()
            }
        }

        document.addEventListener('keydown',eventoEsc)

        return(() => {
            document.removeEventListener('keydown',eventoEsc)
        })
    },[])

    return (
    <>  
        {isOpen ? (
            <>
                <Draggable handle="strong" disabled={!isDragrable}>
                    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto rounded-xl fixed inset-0 z-[1050] outline-none focus:outline-none">
                        <div className={`relative w-auto my-6 mx-auto max-w-[90%] lg:w-[90%] lg:max-h-[90%] lg:overflow-auto rounded-xl`} style={{boxShadow: 'rgb(0 0 0) 0px 0px 25px 8px'}}>
                        {/*content*/}
                            <div className="bg-[#2d2f30] border-0 rounded-2xl  shadow-lg relative flex flex-col w-full outline-none focus:outline-none">
                                {/*header*/}
                                <strong className="sticky top-0 z-20">
                                    <div className="divMovibleCabecera bg-[#003478]  flex items-start justify-between p-5 border-b border-solid border-[#4e4e4e] rounded-t-xl">
                                        <h3 className="text-xl lg:text-md font-semibold">
                                            {title}
                                        </h3>
                                        <button
                                            className=""
                                            onClick={closeModal}
                                            onTouchEnd={closeModal}
                                            >
                                            <i className="fas fa-times"></i>
                                        </button>
                                    </div>
                                </strong>
                                {/*body*/}
                                <div className={`${paddingModal ? 'p-2' : ''} relative flex-auto bg-[#2f3134] lg:overflow-auto`}>
                                    { children }
                                </div>
                                {/*footer*/}
                                <div className="bg-[#2d2f30] flex items-center justify-end p-6 rounded-b sticky bottom-0">
                                {validButton.confirm ?
                                    <button
                                    className="min-w-[100px] bg-blue-500 hover:bg-blue-600 text-white active:bg-blue-600 font-bold capitalize text-sm px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-xs"
                                    type="button"
                                        onClick={async () => {
                                            mostrarSpinner();
                                            await action();
                                            ocultarSpinner();
                                            // cerrarAlGuardar && closeModal()
                                        }}
                                    >
                                        {
                                            spinner 
                                            ? <Spinner spinner={spinner.toString()}></Spinner>
                                            : <span>{textButtons.confirm}</span>
                                        }
                                    </button>
                                    : ''
                                }
                                {validButton.denied ?
                                    <button
                                    className=" text-white-500 hover:bg-stone-600 rounded background-transparent font-bold capitalize px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-xs"
                                    type="button"
                                    onClick={closeModal}
                                    >
                                        {textButtons.denied} 
                                    </button>
                                    : ''
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="opacity-25 fixed inset-0 z-[1040] bg-black"></div> */}
                </Draggable>
            </>
        ) : null}
        </>
    );
}